import { Box, Container, Typography } from "@mui/material";

import EvaluationStatusTable from "./EvaluationStatus.table";

const EvaluationStatus = () => {
  return (
    <Container maxWidth="xl">
      <Box mt={3}>
        <Typography variant="h2">Training Center</Typography>
      </Box>
      <Box mt={3}>
        <Typography variant="h4" sx={{ my: 1 }}>
          Evaluation Status
        </Typography>
        <Typography variant="body1" sx={{ mb: 3 }}>
          Evaluation Status is used in the NIAP portal to indicate the current
          state of each evaluation project. They are viewable in the Evaluation
          Record and from the associated lab/vendor and validator community
          dashboard.
        </Typography>
        <EvaluationStatusTable />
      </Box>
    </Container>
  );
};

export default EvaluationStatus;
